import {
    createRouter,
    createWebHashHistory
} from 'vue-router'
// import Home from '../views/Home.vue'
import index from '@/views/Home/Index.vue'
const routes = [
        // {
        //     path: '/home',
        //     name: 'Home',
        //     component: Home
        // },
        {
            path: '/',
            name: 'index',
            component: index
                // component: () =>
                //     import('../views/Home/Index.vue')
        },
        {
            path: '/List',
            name: 'List',
            component: () =>
                import ('@/views/List/Index.vue')
        },
        //房屋管理
        {
            path: '/House',
            name: '房屋管理1',
            component: () =>
                import ('@/views/House/Index.vue')
        },
        {
            path: '/HouseDetails',
            name: '房屋查询结果',
            component: () =>
                import ('@/views/House/Details/Index.vue')
        },
        // 支付完成结果
        {
            path: '/PaymentCompleted',
            name: 'PaymentCompleted',
            component: () =>
                import ('@/views/PaymentCompleted/Index.vue')
        },
        // 账户中心
        {
            path: '/AccountCenter',
            name: '账户中心',
            component: () =>
                import ('@/views/AccountCenter/Index.vue')
        },
        // 查询结果
        {
            path: '/QueryResult',
            name: '快捷查询结果',
            component: () =>
                import ('@/views/QueryResult/Index.vue')
        },
        // 房屋查询 Housing inquiry
        {
            path: '/HousingInquiry',
            name: 'HousingInquiry',
            component: () =>
                import ('@/views/HousingInquiry/Index.vue')
        },
        //维修资金交存
        {
            path: '/MaintenanceFundDeposit',
            name: '维修资金交存说明',
            component: () =>
                import ('@/views/MaintenanceFundDeposit/Index.vue')
        },
        //政策法规
        {
            path: '/PoliciesRegulations',
            name: '政策法规',
            component: () =>
                import ('@/views/PoliciesRegulations/Index.vue')
        },
        //法规正文
        {
            path: '/TextOfRegulations',
            name: '法规正文',
            component: () =>
                import ('@/views/TextOfRegulations/Index.vue')
        },
        //应急公示
        {
            path: '/EmergencyPublicity',
            name: '业主表决公示',
            component: () =>
                import ('@/views/EmergencyPublicity/Index.vue')
        },
        //应急公示
        {
            path: '/EmergencyPublicity1',
            name: '应急公示',
            component: () =>
                import ('@/views/EmergencyPublicity1/Index.vue')
        },
        //业主表决
        {
            path: '/OwnersVoting',
            name: '业主表决',
            component: () =>
                import ('@/views/OwnersVoting/Index.vue')
        },
        // 人脸认证
        {
            path: '/FaceRecognition',
            name: '手机号认证',
            component: () =>
                import ('@/views/FaceRecognition/Index.vue')
        },
        //房屋管理的列表
        {
            path: '/HouseAdmin',
            name: '房屋管理111',
            component: () =>
                import ('@/views/HouseAdmin/Index.vue')
        },
        // 房屋管理列表 
        {
            path: '/HousingManagement',
            name: '房屋管理',
            component: () =>
                import ('@/views/HousingManagement/Index.vue')
        },
        // 房屋管理的查询结果 新
        {
            path: '/HouseSearch',
            name: '查询结果',
            component: () =>
                import ('@/views/HouseSearch/Index.vue')
        },
        // 维修项目查询 新
        {
            path: '/MaintenanceItems',
            name: '维修项目查询',
            component: () =>
                import ('@/views/MaintenanceItems/Index.vue')
        },
        // 我的表决 新
        {
            path: '/MyVote',
            name: '我的表决',
            component: () =>
                import ('@/views/MyVote/Index.vue')
        },
        {
            // 
            path: '/DepositDetails',
            name: '交存明细',
            component: () =>
                import ('@/views/DepositDetails/Index.vue')
        },
        //测试
        {
            path: '/textone',
            name: '测试1111',
            component: () =>
                import ('@/views/Text/Index.vue')
        },
        //通知公告
        {
            path: '/Notice',
            name: '通知公告',
            component: () =>
                import ('@/views/Notice/Index.vue')
        },
        //测试
        {
            path: '/ceshi',
            name: '测试',
            component: () =>
                import ('@/views/Text/text.vue')
        },
        //图片预览的测试
        {
            path: '/ImageText',
            name: '图片预览测试',
            component: () =>
                import ('@/views/ImageText/Index.vue')
        },
        //tab切换的测试
        {
            path: '/TabText',
            name: 'tab切换的测试',
            component: () =>
                import ('@/views/TabText/Index.vue')
        },
        {
            path: '/ButText',
            name: 'But测试',
            component: () =>
                import ('@/views/ButText/Index.vue')
        },
        {
            // 
            path: '/about',
            name: 'about',
            component: () =>
                import ('@/views/About.vue')
        },
        {
            // 
            path: '/ProjectSearch',
            name: '维修项目',
            component: () =>
                import ('@/views/ProjectSearch/Index.vue')
        },
        {
            // 
            path: '/ProjectList',
            name: '维修项目列表',
            component: () =>
                import ('@/views/ProjectSearch/ProjectList/Index.vue')
        },
        {
            path: '/RedirectResult',
            name: 'RedirectResult',
            component: () =>
                import ('@/views/RedirectResult.vue')
        },
        //实名认证
        {
            path: '/RealNameAuthentication',
            name: '实名认证',
            component: () =>
                import ('@/views/RealNameAuthentication/Index.vue')
        },
        //通知公告的组件
        {
            path: '/AuthenticationSet',
            name: 'AuthenticationSet',
            component: () =>
                import ('@/components/AuthenticationSet/Index.vue')
        },
        //业主表决的组件
        {
            path: '/VotingsOwner',
            name: 'VotingsOwner',
            component: () =>
                import ('@/components/VotingsOwner/Index.vue')
        },
        //应急公示的组件
        {
            path: '/MeetAnEmergency',
            name: 'MeetAnEmergency',
            component: () =>
                import ('@/components/MeetAnEmergency/Index.vue')
        },
        //session测试
        {
            path: '/SessionText',
            name: 'SessionText',
            component: () =>
                import ('@/views/SessionText/Index.vue')
        },
        // 从这开始写的
        {
            path: '/PersonalCenter',
            name: '个人中心',
            component: () =>
                import ('@/views/PersonalCenter/Index.vue')
        },
        {
            path: '/RechargeList',
            name: '充值',
            component: () =>
                import ('@/views/RechargeList/Index.vue')
        },
        {
            path: '/AddNewAddress',
            name: '新增地址',
            component: () =>
                import ('@/views/AddNewAddress/Index.vue')
        },
        {
            path: '/HousingDetails',
            name: '详情',
            component: () =>
                import ('@/views/HousingDetails/Index.vue')
        },
        {
            path: '/NoticeDetails',
            name: '通知详情',
            component: () =>
                import ('@/views/NoticeDetails/Index.vue')
        },
        {
            path: '/BillingRecords',
            name: '账单记录',
            component: () =>
                import ('@/views/BillingRecords/Index.vue')
        },
        {
            path: '/HistoricalRecharge',
            name: '充值记录',
            component: () =>
                import ('@/views/HistoricalRecharge/Index.vue')
        },{
            path: '/HistoricalBills',
            name: '交费历史',
            component: () =>
                import ('@/views/HistoricalBills/Index.vue')
        },{
            path: '/ConfirmPayment',
            name: '确认支付',
            component: () =>
                import ('@/views/ConfirmPayment/index.vue')
        },{
            path: '/echartsText',
            name: 'echarts',
            component: () =>
                import ('@/views/echartsText/Index.vue')
        }
    ]
    // const menu = [];
    /**
     * 动态路由实现思路 ：
     * 1、登陆成功后将menu信息存之store
     * 2、beforerouter是判断store中是否存在menu信息，存在直接addroute，不存在重新请求再addroute
     * 3、记得最后拼接404
     * 
     * 使用下面这句话实现获取view下的vue文件
     * export const webpackContext = require.context('@/views', true, /\.vue$/, 'lazy')
     **/

// routes.concat(menu);

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router